import React from 'react';
import PropTypes from 'prop-types';
import styles from './OrderRejectionForm.module.scss';
import InputNumber from 'rc-input-number';
import { numberFormatter } from '../../../utils/formatHelper';
import { VARIANT_IDENTIFIER_SKU, VariantIdentifierDisplayName } from '../../../constants/variantIdentifiers';
import { NO_VALUE_PLACEHOLDER } from '../../../constants/tables';

function OrderRejectionForm(props) {
  const { fulfillment, maxQuantities } = props;
  const { quantities } = props.rejection;
  const readonly = !!props.readonly;

  function onChange(key, value) {
    props.onChange({
      [key]: value,
    });
  }

  function currentValue(fulfillmentLineId) {
    return quantities.hasOwnProperty(fulfillmentLineId)
      ? quantities[fulfillmentLineId]
      : maxQuantities[fulfillmentLineId];
  }

  return (
    <div className={styles.rejection}>
      <table className={styles.rejectionLines}>
        <thead>
          <tr>
            <th className={styles.productsCol}>Product</th>
            <th className={styles.identifierCol}>{VariantIdentifierDisplayName[VARIANT_IDENTIFIER_SKU]}</th>
            <th>Ordered</th>
            <th>{readonly ? 'Rejected' : 'Reject'}</th>
          </tr>
        </thead>
        <tbody>
          {fulfillment.fulfillment_lines.map((line) => (
            <tr key={line.id} data-testid={`fulfillment-line-${line.id}`}>
              <td className={styles.productsCol}>{line.variant.title}</td>
              <td className={styles.identifierCol}>{line.variant[VARIANT_IDENTIFIER_SKU]}</td>
              <td data-testid={`fulfillment-line-quantity-${line.id}`}>{line.original_quantity || line.quantity}</td>
              <td className={styles.quantityCol}>
                {readonly ? (
                  quantities[line.id] || NO_VALUE_PLACEHOLDER
                ) : (
                  <InputNumber
                    min={0}
                    max={maxQuantities[line.id]}
                    value={currentValue(line.id)}
                    onChange={(number) => {
                      onChange('quantities', { [line.id]: number });
                    }}
                    formatter={numberFormatter}
                    data-testid={`fulfillment-line-input-${line.id}`}
                  />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

OrderRejectionForm.propTypes = {
  maxQuantities: PropTypes.object,
  fulfillment: PropTypes.shape({
    fulfillment_lines: PropTypes.array.isRequired,
  }).isRequired,
  rejection: PropTypes.shape({
    quantities: PropTypes.object.isRequired,
  }).isRequired,
  onChange: PropTypes.func,
  readonly: PropTypes.bool,
};
export default OrderRejectionForm;
